import { z } from 'zod'
import { PaymentInterval } from '@/types/purchase/PaymentInterval'
import { Product } from '../product/Product'

export const CartItem = z.object({
  count: z
    .number()
    .int()
    .min(-9_223_372_036_854_775_808)
    // eslint-disable-next-line no-loss-of-precision
    .max(9_223_372_036_854_775_807),
  // product: z.union([AdminProduct.shape.slug, AdminProduct]),
  product: Product.shape.slug,
  payment_interval: PaymentInterval.optional(),
  meta_data: z.record(z.string(), z.string()).optional()
})

export type CartItem = z.infer<typeof CartItem>
